import "@shared/assets/styles/popup_common.custom.css"

import React from "react"

import { LayerPopupProvider } from "@shared/contexts"

import { StreamerHotkeys } from "streamerHotkeys/components"

function StreamerHotkeysPage() {
  return (
    <LayerPopupProvider>
      <StreamerHotkeys />
    </LayerPopupProvider>
  )
}

export default StreamerHotkeysPage
